"use strict";

var processInclude = require("base/util");
const { initCarousel } = require("./components/carousels");

$(document).ready(function () {
    processInclude(require("./product/detail"));
    processInclude(require("./utils/popoverUtils"));
    processInclude(require("./product/ahumadaContigo3ra"));
    initCarousel(".ahumada-recommendation-carousel");
    initCarousel(".ahumada-related-carousel", {}, ".ahumada-related-carousel-wrapper");
    processInclude(require("plugin_wishlists/product/wishlist"));
});
